import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Clock, X } from "lucide-react";
import { useTemporaryChat } from "../hooks/use-temporary-chat";
import { HarmonyTemoporaryChatIcon } from "@/components/icons";
import { cn } from "@/lib/utils";
import { headerActionClass } from "@/components/layout/header-action";

export const TemporaryChatButton: React.FC = () => {
  const { t } = useTranslation();
  const { handleToggleTemporaryMode, isTemporaryMode } = useTemporaryChat();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleToggleTemporaryMode}
            className={cn(
              headerActionClass,
              "size-8 p-0",
              isTemporaryMode &&
                "bg-module-accent-soft text-module-accent hover:bg-module-accent-soft hover:text-module-accent",
            )}
          >
            <HarmonyTemoporaryChatIcon size={16} enabled={isTemporaryMode} />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="max-w-xs">
          <div className="text-center">
            <div className="mb-1 flex items-center justify-center">
              {isTemporaryMode ? (
                <X className="mr-1 size-4" />
              ) : (
                <Clock className="mr-1 size-4" />
              )}
              <span className="font-medium">
                {isTemporaryMode
                  ? t("temporaryChat.tooltip.titleOff")
                  : t("temporaryChat.tooltip.title")}
              </span>
            </div>
            <p className="text-sm text-muted-foreground">
              {isTemporaryMode
                ? t("temporaryChat.tooltip.descriptionOff")
                : t("temporaryChat.tooltip.description")}
            </p>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
